import {Directive, Input, TemplateRef} from "@angular/core";

@Directive({
  selector: '[hrmTemplate]',
  host: {}
})
export class HrmTemplate {
  @Input() type: string | undefined;

  @Input('hrmTemplate') name: string | undefined;

  constructor(public template: TemplateRef<any>) {}

  getType(): string {
    return this.name!;
  }
}
